import { useEffect, useState } from 'react'

const MOBILE_MENU_QUERY = '(max-width: 1024px)'

const getInitialMatch = () => globalThis.matchMedia?.(MOBILE_MENU_QUERY).matches ?? false

/**
 * Mantiene un único breakpoint para el header y las variantes del menú.
 * @returns {boolean} true para viewports de hasta 1024px inclusive.
 */
export function useIsMobileMenu() {
  const [isMobile, setIsMobile] = useState(getInitialMatch)

  useEffect(() => {
    const mediaQuery = globalThis.matchMedia(MOBILE_MENU_QUERY)
    const handleChange = (event) => setIsMobile(event.matches)

    mediaQuery.addEventListener('change', handleChange)
    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [])

  return isMobile
}
